export const SHARED_USER_SEGMENTS = {
  AMEX_CARDHOLDER: '1352056',
  KNOWN_GUEST: '1352055',
  NOT_COBRAND_CARDMEMBER: '1400719',
  NOT_KNOWN_GUEST: '1352057',
  H4B_LOYALTY: '1569935',
  H4B_ACQUISITION: '1591986',
} as const satisfies Record<string, string>;
